import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "view",
  id: "news"
}
const _hoisted_2 = { class: "date" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "link-wrap" }, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "left"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "This article doesn't exist.", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "box-shadow right reversed" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("news"),
  /*#__PURE__*/_createElementVNode("span", null, "من الاخبار")
], -1)
const _hoisted_11 = { class: "news-wrap" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "top" }
const _hoisted_14 = { class: "img-wrap" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "title-wrap" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.activePost !== null && _ctx.posts)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["left", _ctx.posts.news[_ctx.activePost].custom_fields.language])
          }, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.posts.news[_ctx.activePost].post_title), 1),
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.posts.news[_ctx.activePost].custom_fields.date), 1),
            _createElementVNode("img", {
              src: _ctx.posts.news[_ctx.activePost].custom_fields.image.sizes.medium_large
            }, null, 8, _hoisted_3),
            _createElementVNode("div", {
              innerHTML: _ctx.posts.news[_ctx.activePost].post_content
            }, null, 8, _hoisted_4),
            _hoisted_5
          ], 2))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)),
      _createElementVNode("div", {
        class: _normalizeClass(["right", {'stopped': _ctx.scrolled}]),
        id: "newsWrap"
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_ctx.posts && _ctx.posts.news)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.posts.news, (post, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["post right", {'arabic': post.custom_fields.language == 'arabic', 'chosen': index == _ctx.activePost}]),
                      onClick: $event => (_ctx.setActivePost(index))
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            (post.custom_fields.image)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: post.custom_fields.image.sizes.thumbnail
                                }, null, 8, _hoisted_15))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("h3", null, _toDisplayString(post.post_title), 1)
                          ])
                        ])
                      ])
                    ], 10, _hoisted_12))
                  }), 256))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}